interface Passenger {
    passengerId: string;
    passengerName: string;
    passengerEmail: string;
    passengerPhone: string;
  }

interface AuthorizedClient {
  clientable_id: number;
  clientable_type: string;
  created_at: string;
  deleted_at: string | null;
  email: string;
  id: number;
  name: string;
  phone: string | null;
  updated_at: string;
}
  
interface Company {
  business_name: string;
  id: string;
}

export enum Status {
  VERIFIED = 'VERIFIED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}
export enum Role {
  CORPORATE = 'CORPORATE',
  PARTICULAR = 'PARTICULAR',
}
export enum UserType {
  PARTICULAR = 'particular',
  CORPORATE = 'corporate',
  CORPORATE_PARTICULAR = 'corporate_particular',
}

export interface User {
  id: string;
  createdAt: string;
  number: number;
  role: Role;
  user_type: UserType;
  username: string;
  status: Status;
  reservations: number;
  passengers: Passenger[];
  fullname: string;
  phone: string;
  email: string;
  company: Company;
  is_active: boolean;
  authorized: AuthorizedClient[];
  authorized_id: number | null;
}

export interface appUserModel {
    docs: User[];
    totalDocs: number;
    limit: number;
    totalPages: number;
    page: number;
    pagingCounter: number;
    hasPrevPage: boolean;
    hasNextPage: boolean;
    prevPage: number | null;
    nextPage: number | null;
}



